// StickyHeaderMenu.jsx
import React, { useState, useRef, useEffect } from "react";
import MenuV2 from "./MenuV2";
import { createOverlay, removeOverlay } from "../overlay"
import { fetchProductCategoryList } from "api/ProductCategory";
import { getProductGroupList } from "api/ProductGroup";
import { Link, useLocation } from "react-router-dom";

export default function StickyHeaderMenu() {
    const [open, setOpen] = useState(false)
    const [categories, setCategories] = useState<any[]>([]);
    const [groups, setGroups] = useState<any[]>([]);
    const closeTimer = useRef<NodeJS.Timeout | null>(null)
    const location = useLocation();
    const { pathname } = location;

    const isPathActive = (paths: string[]) => {
        if (pathname === "/" && paths.includes("/")) {
            return true;
        }

        if (pathname === "/") {
            return false;
        }

        return paths.some((path) => pathname === path || pathname.startsWith(`${path}/`));
    };

    const isProductsActive = isPathActive(["/products", "/product"]);
    const isOverviewActive = pathname === "/tong-quan";
    const isQuickOrderActive = isPathActive(["/quick-order"]);
    const isPromotionActive = isPathActive(["/promotion"]);
    const isPromoCodesActive = isPathActive(["/promo-codes"]);

    /* ================= CLOSE ON NAVIGATION ================= */
    useEffect(() => {
        setOpen(false)
    }, [pathname, location.search])

    /* ================= DATA FETCHING ================= */
    useEffect(() => {
        const fetchData = async () => {
            try {
                const [catRes, groupRes] = await Promise.all([
                    fetchProductCategoryList(),
                    getProductGroupList()
                ]);
                if (catRes.status) {
                    setCategories(catRes.data.items);
                }
                setGroups(groupRes);
            } catch (error) {
                console.error("Failed to fetch menu data", error);
            }
        };
        fetchData();
    }, []);

    /* ================= OVERLAY EFFECT ================= */
    useEffect(() => {
        if (open) {
            createOverlay(() => {
                setOpen(false)
            })
        } else {
            removeOverlay()
        }

        return () => {
            removeOverlay()
        }
    }, [open])

    /* ================= HOVER HANDLERS ================= */
    const handleEnter = () => {
        if (closeTimer.current) {
            clearTimeout(closeTimer.current)
            closeTimer.current = null
        }
        setOpen(true)
    }

    const handleLeave = () => {
        closeTimer.current = setTimeout(() => {
            setOpen(false)
        }, 120) // giống thuocsi (~100–150ms)
    }

    return (
        <div className="styles_stickyHeaderMenu__UKzGl styles_stickyTopSearch__XCqci hidden-1199">
            <div className="styles_nav__gjQVz MuiBox-root css-0">
                <div
                    className="MuiContainer-root styles_wrap__MTNld MuiContainer-maxWidthLg"
                    style={{ maxWidth: 1180 }}
                >
                    <div className="styles_WrapmenuFocus__aMUXE MuiBox-root css-0">
                        {/* MENU LEFT */}
                        <div
                            className="MuiGrid-root styles_menu__3jSIP styles_h40__NJwsv MuiGrid-container"
                            style={{ width: "100%", transition: "width 1s" }}
                        >
                            {/* SẢN PHẨM */}
                            <div
                                className={[
                                    "styles_MenuTrigger__RkWVE",
                                    isProductsActive && "styles_active__sCa_A",
                                    open && "styles_isActiveMenu__boSSG",
                                ]
                                    .filter(Boolean)
                                    .join(" ")}
                                onMouseEnter={handleEnter}
                                onMouseLeave={handleLeave}
                            >
                                <div
                                    className="styles_link__t2Gkc"
                                >
                                    <Link
                                        to="/products"
                                        className="styles_mobile_rootBase__8z7PQ styles_flexItem__D9O0C"
                                        style={{ padding: 0 }}
                                    >
                                        <div className="styles_menuIcons__zD_BG">
                                            <div
                                                className="image-container"
                                                style={{
                                                    position: "relative",
                                                    width: 20,
                                                    height: 20,
                                                    overflow: "hidden",
                                                    backgroundSize: "cover",
                                                    backgroundPosition: "center",
                                                    backgroundImage:
                                                        'url("https://gcs.buymed.com/thuocsi-live/internal/cms/202463a7f98426bd4c8d99568c93d450San_Pham.svg")',
                                                    transition: "background-image 0.3s",
                                                }}
                                            />
                                        </div>
                                        <p className="MuiTypography-root MuiTypography-body2">
                                            Sản Phẩm
                                        </p>
                                        <div className="icon-right">
                                            <img
                                                src="https://cdn-web-next.thuocsi.vn/icons/arrow-down.svg"
                                                alt=""
                                                style={{ width: 20, height: 20 }}
                                            />
                                        </div>
                                    </Link>
                                </div>
                                {open && <MenuV2 categories={categories} groups={groups} />}
                            </div>

                            {/* TỔNG QUAN (ACTIVE) */}
                            <div
                                className={[
                                    "styles_link__t2Gkc",
                                    isOverviewActive && "styles_active__sCa_A",
                                ]
                                    .filter(Boolean)
                                    .join(" ")}
                            >
                                <Link
                                    to="/tong-quan"
                                    className="styles_mobile_rootBase__8z7PQ styles_flexItem__D9O0C"
                                    style={{ padding: 0 }}
                                >
                                    <div className="styles_menuIcons__zD_BG">
                                        <div
                                            className="image-container"
                                            style={{
                                                width: 20,
                                                height: 20,
                                                backgroundImage:
                                                    'url("https://gcs.buymed.com/thuocsi-live/internal/cms/20253d8773161c7952474f688086d19eSale_to_cuoi_nam.svg")',
                                                backgroundSize: "cover",
                                            }}
                                        />
                                    </div>
                                    <p className="MuiTypography-root MuiTypography-body2">
                                        Tổng Quan
                                    </p>
                                </Link>
                            </div>

                            {/* ĐẶT HÀNG NHANH */}
                            <MenuItem
                                href="/quick-order"
                                text="Đặt Hàng Nhanh"
                                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/20247ffb97df94878bf089ada4f730c2Quick_Order.svg"
                                active={isQuickOrderActive}
                            />

                            {/* KHUYẾN MÃI */}
                            <MenuItem
                                href="/promotion"
                                text="Khuyến Mãi"
                                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/20240b1377a79738145e16e08211075fKM.svg"
                                active={isPromotionActive}
                            />

                            {/* NHÀ BÁN HÀNG */}
                            {/* <MenuItem
                                href="/sellers"
                                text="Nhà Bán Hàng"
                                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/202438a46555132fd888825911b60a2fFrame.svg"
                            /> */}

                            {/* MÃ GIẢM GIÁ */}
                            <MenuItem
                                href="/promo-codes"
                                text="Mã Giảm Giá"
                                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/2024a85f60f71c003bf40f2ee196c1cbLayer_1.svg"
                                active={isPromoCodesActive}
                            />
                            {/* <MenuItem
                                href="https://thuocsi.vn/products?tag=AW4A&utm_source=website&utm_medium=menu_bar&utm_campaign=camp_active&utm_term=202503&utm_content=camp_active"
                                text="Giá Mới Tốt Hơn"
                                icon="https://gcs.buymed.com/thuocsi-live/internal/cms/2025370b44ec2fc7b969c7cecb831c26fire_1.svg"
                            /> */}
                        </div>

                        {/* SEARCH */}
                        <div
                            className="styles_wrapSticky__ME2_Y MuiBox-root css-0"
                            style={{ width: "25%", transition: "width 1s" }}
                        >
                            <div className="styles_search_wrap__HLrm2 styles_hiddenWidth__qcqaa">
                                <input
                                    type="search"
                                    placeholder=""
                                    className="MuiInputBase-input MuiInput-input"
                                />
                            </div>
                        </div>

                        {/* CART */}
                        <div className="styles_wrapStickRight__l8xSS MuiBox-root css-0">
                            <Link
                                to="/cart"
                                className="styles_mobile_rootBase__8z7PQ styles_cartLink__9Ajbt styles_cartSticky__QS8Iw"
                            >
                                <div title="Giỏ hàng">
                                    <img
                                        src="https://cdn-web-next.thuocsi.vn/images/header-v2/Cartv2_icon.svg"
                                        alt="cart"
                                        width={20}
                                    />
                                    <span className="MuiBadge-badge">3</span>
                                </div>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

/* COMPONENT CON */
function MenuItem({ href, icon, text, active }: { href: string; icon: string; text: string; active?: boolean }) {
    return (
        <div
            className={[
                "styles_link__t2Gkc",
                active && "styles_active__sCa_A",
            ]
                .filter(Boolean)
                .join(" ")}
        >
            <Link
                to={href}
                className="styles_mobile_rootBase__8z7PQ styles_flexItem__D9O0C"
                style={{ padding: 0 }}
            >
                <div className="styles_menuIcons__zD_BG">
                    <div
                        className="image-container"
                        style={{
                            width: 20,
                            height: 20,
                            backgroundImage: `url("${icon}")`,
                            backgroundSize: "cover",
                        }}
                    />
                </div>
                <p className="MuiTypography-root MuiTypography-body2">{text}</p>
            </Link>
        </div>
    );
}
